var map = {
	"./alpaca-logo.png": 7017,
	"./bard-logo.svg": 6314,
	"./bing-balanced-logo.png": 7724,
	"./bing-creative-logo.png": 3268,
	"./bing-logo.svg": 9117,
	"./bing-precise-logo.png": 6257,
	"./chatglm-logo.svg": 669,
	"./chatgpt-35-logo.png": 9743,
	"./chatgpt-4-logo.png": 9649,
	"./chatgpt-browsing-logo.png": 7821,
	"./chatgpt-logo.svg": 9383,
	"./claude-logo.png": 2927,
	"./default-logo.svg": 5021,
	"./ernie-logo.png": 4457,
	"./gradio-logo.svg": 3171,
	"./huggingchat-logo.png": 4070,
	"./lmsys-logo.png": 2822,
	"./moss-logo.png": 6275,
	"./openai-35-logo.png": 140,
	"./openai-4-logo.png": 1281,
	"./openai-logo.svg": 3549,
	"./spark-logo.png": 4999,
	"./vicuna-logo.jpeg": 4278,
	"./wenxin-qianfan-logo.png": 9588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1953;